module.exports = __webpack_public_path__ + "img/innovations@2x.cfc8e6f3.webp";